import { Component, OnInit, transition, animate, trigger, style } from '@angular/core';

@Component({
  selector: 'app-approvals-views',
  animations: [
    trigger('fadeInOutTranslate', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate(300, style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ transform: 'translate(0)' }),
        animate(300, style({ opacity: 0 }))
      ])
    ])
  ],
  templateUrl: './approvals-views.component.html',
  styleUrls: ['./approvals-views.component.scss']
})
export class ApprovalsViewsComponent implements OnInit {
  constructor() { }

  toggleComment = {};
  oldApprovalsList = [];

  pendingApprovalsList = [
    {
      id: 1,
      title: 'Example 1',
      comment: ''
    },
    {
      id: 2,
      title: 'Example 2',
      comment: ''
    },
    {
      id: 3,
      title: 'Example 3',
      comment: ''
    }
  ];

  handleApprovalAction(index, status) {
    const itemRemoved = this.pendingApprovalsList.splice(index, 1)[0];
    const newItem = Object.assign({}, itemRemoved, { status });
    this.oldApprovalsList.push(newItem);
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/approvals-views/approvals-views.component.ts